import type { GroupColor } from '@gm-binder/shared';

/** Selectable identity hues for a group, in palette order. */
export const GROUP_COLORS: GroupColor[] = ['gold', 'ember', 'sage', 'azure', 'plum', 'copper'];

/** CSS value for a group's identity hue (maps to the `--group-*` tokens). */
export function groupAccent(color: GroupColor): string {
  return `var(--group-${color})`;
}

/** Up to two initials for an avatar, from a person or group name. */
export function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean).slice(0, 2);
  const out = parts.map((p) => p[0]?.toUpperCase() ?? '').join('');
  return out || '?';
}

/** Italian-correct "N sessione/sessioni" label. */
export function sessionsLabel(n: number): string {
  return `${n} ${n === 1 ? 'sessione' : 'sessioni'}`;
}
